export enum PosMarketStatus {
  Available = "Available",
  ComingSoon = "ComingSoon"
}

export enum PosMarketOpenMode {
  None = "None",
  NewWindow = "NewWindow",
  Iframe = "Iframe"
}

export enum PosMarketplaceAvailability {
  Available = "Available",
  Locked = "Locked",
  NotAvailable = "NotAvailable"
}

export enum PosMarketplaceUnlockReason {
  PlanUpgradeRequired = "PlanUpgradeRequired"
}
